import { useTranslation } from "@/features/utils/i18n";
import { getIntegration } from "../catalog";

/**
 * An integration's name in the reader's language: its translation when it has one
 * (`tools.integrations.<id>.name`), else the catalogue's, else the caller's fallback
 * (the server's label) or the id itself — so an integration the front does not know
 * yet still shows up.
 *
 * Returns the lookup rather than one name, for the lists and sorts that need several.
 */
export function useIntegrationName() {
  const { t } = useTranslation("tools");
  return (id: string | undefined | null, fallback?: string): string =>
    id
      ? t(`tools.integrations.${id}.name`, {
          defaultValue: getIntegration(id)?.name ?? fallback ?? id,
        })
      : "";
}
